import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseLoading = _resolveComponent("BaseLoading")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_ModalVerifyAccount = _resolveComponent("ModalVerifyAccount")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_BaseLoading, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view, { style: {"min-height":"100vh"} }),
    _createVNode(_component_ModalVerifyAccount)
  ], 64))
}